export const environmentConfig = {
  name: '环境管理',
  description: '打造健康、舒适、可持续的生活环境',
  icon: 'EnvironmentOutlined',
  bgColor: '#52C41A',
  iconColor: '#FFFFFF',
  
  // API端点
  apiEndpoints: {
    environments: '/environment',
    createEnvironment: '/environment',
    updateEnvironment: '/environment',
    deleteEnvironment: '/environment',
    followUps: '/environment/follow-ups',
    createFollowUp: '/environment/follow-ups',
    planning: '/environment/planning',
    createPlanning: '/environment/planning',
    resources: '/environment/resources',
    createResource: '/environment/resources',
    pollution: '/environment/pollution',
    createPollution: '/environment/pollution',
    stats: '/environment/stats'
  },

  // 环境类型定义
  environmentTypes: [
    {
      key: 'home_planning',
      name: '家居环境规划',
      icon: '🏠',
      color: '#1890FF',
      description: '家居空间布局和功能规划'
    },
    {
      key: 'resource_management',
      name: '家居资源管理',
      icon: '🌿',
      color: '#52C41A',
      description: '家居资源的合理配置和管理'
    },
    {
      key: 'pollution_control',
      name: '污染控制',
      icon: '🛡️',
      color: '#FAAD14',
      description: '室内外环境污染的预防和控制'
    },
    {
      key: 'energy_efficiency',
      name: '节能环保',
      icon: '⚡',
      color: '#722ED1',
      description: '能源使用效率和环保措施'
    },
    {
      key: 'air_quality',
      name: '空气质量',
      icon: '💨',
      color: '#13C2C2',
      description: '室内空气质量的监测和改善'
    },
    {
      key: 'waste_management',
      name: '废物管理',
      icon: '♻️',
      color: '#F5222D',
      description: '垃圾分类和废物处理'
    }
  ],

  // 实施状态
  implementationStatus: [
    { key: 'planned', name: '已规划', color: 'blue' },
    { key: 'in_progress', name: '进行中', color: 'orange' },
    { key: 'completed', name: '已完成', color: 'green' },
    { key: 'paused', name: '暂停', color: 'red' },
    { key: 'cancelled', name: '已取消', color: 'default' }
  ],

  // 优先级
  priorities: [
    { key: 'high', name: '高', color: 'red' },
    { key: 'medium', name: '中', color: 'orange' },
    { key: 'low', name: '低', color: 'green' }
  ],

  // 环境管理TIPS
  environmentManagementTips: {
    title: '环境管理五大原则',
    description: '打造健康、舒适、可持续的生活环境',
    principles: [
      {
        title: '健康优先',
        description: '确保室内环境对健康无害，优先考虑空气质量、光照、噪音等因素',
        icon: '❤️'
      },
      {
        title: '舒适宜居',
        description: '创造舒适的生活环境，合理布局空间，优化温度和湿度',
        icon: '🏡'
      },
      {
        title: '节能环保',
        description: '采用节能技术和环保材料，减少能源消耗和环境污染',
        icon: '🌱'
      },
      {
        title: '可持续性',
        description: '选择可再生和可回收的材料，建立长期的环境管理机制',
        icon: '♻️'
      },
      {
        title: '个性化',
        description: '根据家庭成员的需求和偏好，定制个性化的环境方案',
        icon: '👥'
      }
    ]
  },

  // 环境管理流程
  environmentManagementProcess: {
    title: '环境管理实施流程',
    description: '从规划到实施的完整环境管理流程',
    steps: [
      {
        step: 1,
        title: '环境评估',
        icon: '🔍',
        description: '评估当前环境状况，识别问题和改进机会',
        details: '包括空气质量检测、噪音测量、光照分析等'
      },
      {
        step: 2,
        title: '制定规划',
        icon: '📋',
        description: '制定详细的环境改善规划和实施方案',
        details: '设定目标、制定时间表、分配资源'
      },
      {
        step: 3,
        title: '资源准备',
        icon: '🛠️',
        description: '准备必要的设备、材料和人力资源',
        details: '采购环保材料、准备工具、培训人员'
      },
      {
        step: 4,
        title: '实施改善',
        icon: '🚀',
        description: '按照规划实施环境改善措施',
        details: '分步骤实施，确保质量和安全'
      },
      {
        step: 5,
        title: '监测维护',
        icon: '📊',
        description: '持续监测环境质量，定期维护和更新',
        details: '建立监测机制，定期检查和维护'
      }
    ]
  },

  // 家居环境规划TIPS
  homePlanningTips: [
    {
      title: '空间布局',
      description: '合理规划空间布局，确保功能分区明确，动线流畅',
      icon: '📐'
    },
    {
      title: '采光通风',
      description: '充分利用自然光和通风，减少人工照明和空调使用',
      icon: '☀️'
    },
    {
      title: '噪音控制',
      description: '采用隔音材料和设计，减少室内外噪音干扰',
      icon: '🔇'
    },
    {
      title: '温度调节',
      description: '合理设计保温隔热系统，保持舒适的室内温度',
      icon: '🌡️'
    }
  ],

  // 家居资源管理TIPS
  resourceManagementTips: [
    {
      title: '能源管理',
      description: '采用节能设备和智能控制系统，优化能源使用',
      icon: '⚡'
    },
    {
      title: '水资源',
      description: '安装节水设备，收集雨水，循环利用水资源',
      icon: '💧'
    },
    {
      title: '材料选择',
      description: '选择环保、可再生、低污染的建筑和装饰材料',
      icon: '🏗️'
    },
    {
      title: '设备维护',
      description: '定期维护设备，延长使用寿命，减少资源浪费',
      icon: '🔧'
    }
  ],

  // 污染控制TIPS
  pollutionControlTips: [
    {
      title: '空气污染',
      description: '使用空气净化器，种植净化植物，定期通风换气',
      icon: '💨'
    },
    {
      title: '噪音污染',
      description: '采用隔音材料，合理布局，减少噪音源',
      icon: '🔇'
    },
    {
      title: '光污染',
      description: '合理设计照明系统，避免过度照明和光污染',
      icon: '💡'
    },
    {
      title: '化学污染',
      description: '选择低VOC材料，避免使用有害化学物质',
      icon: '🧪'
    }
  ]
};
